import ModuleInvoiceDetail from "./ModuleInvoiceDetail.vue";

export default ModuleInvoiceDetail